import { DashboardSummaryParams } from 'config/requests/dashboard';
import { useGetDashboardMerchantsSummary } from 'pages/Dashboard/DashboardMerchantsSummary/hooks/useGetDashboardMerchantsSummary';
import { useGetDashboardProvidersSummary } from 'pages/Dashboard/DashboardProvidersSummary/hooks/useGetDashboardProvidersSummary';
import { useGetDashboardTransactionsDynamicSummary } from 'pages/Dashboard/DashboardTransactionsDynamicSummary/hooks/useGetDashboardTransactionsDynamicSummary';
import { useGetDashboardTransactionsSuccessSummary } from 'pages/Dashboard/DashboardTransactionsSummary/hooks/useGetDashboardTransactionsSuccessSummary';
import { useGetDashboardTransactionsSummary } from 'pages/Dashboard/DashboardTransactionsSummary/hooks/useGetDashboardTransactionsSummary';

export function useDashboardData(params: DashboardSummaryParams | null) {
  const dashboardTransactionsSummary = useGetDashboardTransactionsSummary(params);
  const dashboardTransactionsSuccessSummary = useGetDashboardTransactionsSuccessSummary(params);
  const dashboardTransactionsDynamicSummary = useGetDashboardTransactionsDynamicSummary(params);
  const dashboardMerchantsSummary = useGetDashboardMerchantsSummary(params);
  const dashboardProvidersSummary = useGetDashboardProvidersSummary(params);

  const summary = dashboardTransactionsSuccessSummary.summary;

  const isLoading =
    dashboardTransactionsSummary?.isLoading ||
    dashboardTransactionsDynamicSummary?.isLoading ||
    dashboardTransactionsSuccessSummary?.isLoading ||
    dashboardMerchantsSummary?.isLoading ||
    dashboardProvidersSummary?.isLoading;

  const hasErrors =
    dashboardTransactionsSummary?.error ||
    dashboardTransactionsDynamicSummary?.error ||
    dashboardTransactionsSuccessSummary?.error ||
    dashboardMerchantsSummary?.error ||
    dashboardProvidersSummary?.error;

  return {
    dashboardTransactionsSummary,
    dashboardTransactionsDynamicSummary,
    dashboardTransactionsSuccessSummary,
    dashboardMerchantsSummary,
    dashboardProvidersSummary,
    isSummaryAvailable: summary !== undefined,
    hasResults: Number(summary?.total) > 0,
    hasErrors,
    isLoading,
  };
}
